/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  VendingMachine,
  VendingMachineInterface,
} from "../VendingMachine";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "assetsAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "prestigeID",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "ItemForSale",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "ItemRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address payable",
        name: "relayerAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "functionSignature",
        type: "bytes",
      },
    ],
    name: "MetaTransactionExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "assets",
    outputs: [
      {
        internalType: "contract IAssets",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "functionSignature",
        type: "bytes",
      },
      {
        internalType: "bytes32",
        name: "sigR",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "sigS",
        type: "bytes32",
      },
      {
        internalType: "uint8",
        name: "sigV",
        type: "uint8",
      },
    ],
    name: "executeMetaTransaction",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getNonce",
    outputs: [
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "itemsForSale",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "sellItem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "stopSellingItem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class VendingMachine__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    assetsAddress: string,
    prestigeID: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<VendingMachine> {
    return super.deploy(
      assetsAddress,
      prestigeID,
      overrides || {}
    ) as Promise<VendingMachine>;
  }
  getDeployTransaction(
    assetsAddress: string,
    prestigeID: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      assetsAddress,
      prestigeID,
      overrides || {}
    );
  }
  attach(address: string): VendingMachine {
    return super.attach(address) as VendingMachine;
  }
  connect(signer: Signer): VendingMachine__factory {
    return super.connect(signer) as VendingMachine__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): VendingMachineInterface {
    return new utils.Interface(_abi) as VendingMachineInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): VendingMachine {
    return new Contract(address, _abi, signerOrProvider) as VendingMachine;
  }
}
